import * as bootstrap from "bootstrap"

import { Application } from "@hotwired/stimulus"
import PhotoUploadController from "./controllers/photo_upload_controller"
import NewsletterController from "./controllers/newsletter_controller"

const application = Application.start()
application.register("photo-upload", PhotoUploadController)
application.register("newsletter", NewsletterController)
